import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { UserAPIService } from "../../shared/services/API/UserAPI.service";
import { CatalogPaginationRequest } from "../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../shared/models/Filter/FilterRequest";

@Injectable({
  providedIn: "root",
})
export class UserService {
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();
  public otherCustomers$: Subject<any> = new Subject<any>();
  public updateOtherCustomers$: Subject<any> = new Subject<any>();
  public otherCustomers: any;
  public updateOtherCustomers: any = {};
  public isUpdateUser: boolean = false;

  public catalogFilterModule = 'UserCatalog';
  
  constructor(private userService: UserAPIService) {
  }

  // getUsersPaged(): Observable<any[]> {
  //   return this.http.get<UsersPaged[]>(this.configUrl + "/api/AuthManagement/GetUsers", {});
  // }

  setOtherCustomers(customers) {
    this.otherCustomers = customers;
    this.otherCustomers$.next(customers);
  }

  getOtherCustomers() {
    return this.otherCustomers$.asObservable();
  }

  setUpdateOtherCustomers(updateCustomers) {
    this.updateOtherCustomers = updateCustomers;
    this.updateOtherCustomers$.next(updateCustomers);
  }

  getUpdateOtherCustomers() {
    return this.updateOtherCustomers$.asObservable();
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }



  delete(UserId): any{
    return this.userService.delete(UserId);
  }

  getUpdateUser(id): Observable<EstatusJSON>{
    return this.userService.getUpdateUser(id);
  }

  //cambió de InsertUser a registerUser
  getInsertUser(): Observable<EstatusJSON>{
    return this.userService.getInsertUser();
  }

  //cambió de InsertUser a registerUser
  postInsertUser(formData: any): Observable<EstatusJSON> {
    return this.userService.postInsertUser(formData);
  }

  postUpdateUser(formData: any): Observable<EstatusJSON> {
    return this.userService.postUpdateUser(formData);
  }

  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.userService.getFilterValues(request);
  }

  getPage(pageRequest: CatalogPaginationRequest) {
    return this.userService.getPage(pageRequest);
  }

  getCount(pageRequest: CatalogPaginationRequest) {
    return this.userService.getCount(pageRequest);
  }
  
}
